/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Creating_JobInputs */



/**
* | output |
* | --- |
* | "Creating Publish Job" |
*
* @param {Iconik_Publish_Status_Creating_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_creating_job = /** @type {((inputs?: Iconik_Publish_Status_Creating_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Creating_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creation de la tache de publication")
	if (locale === "de") return /** @type {LocalizedString} */ ("Job veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione di un lavoro di pubblicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание и публикация задания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando un trabajo de publicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建发布作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開ジョブの作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन कार्य बनाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar vaga de publicação")
	return /** @type {LocalizedString} */ ("Creating Publish Job")
});